module.exports = __webpack_public_path__ + "static/6-03ceb3fbc281b5aff7bde38e12007660.jpg";